import { render } from "./NavigationLinks.vue?vue&type=template&id=b1596e66"
import script from "./NavigationLinks.vue?vue&type=script&lang=ts"
export * from "./NavigationLinks.vue?vue&type=script&lang=ts"

import "./NavigationLinks.vue?vue&type=style&index=0&id=b1596e66&lang=css"
script.render = render

export default script